import { LinearProgress } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import AttachFile from "@material-ui/icons/AttachFile";
import React, { FC } from "react";
import { downloadExamCaseDocument } from "../../api/ExamCaseApi";
import { useGetExamCasesQuery } from "../../api/rtk/ExamCaseApi";
import DocumentList from "../common/DocumentList";
import TranslatedMessage from "../translations/TranslatedMessage";
import HomeSection from "./HomeSection";

export const MyExamCases: FC = () => {
  const { data: examCases, isFetching: isExamCasesFetching } = useGetExamCasesQuery(undefined);
  const isLoading = isExamCasesFetching;

  if (!isLoading && examCases === undefined) {
    return <></>;
  }

  return (
    <HomeSection icon={<AttachFile />} title={<TranslatedMessage id="home.myExamCases" />}>
      <Grid container={true} spacing={8}>
        <Grid item={true} xs={12}>
          {isLoading && <LinearProgress variant="query" />}
          {!isLoading && (
            <DocumentList documents={examCases!} onDownloadFile={(file) => downloadExamCaseDocument(file.name)} />
          )}
        </Grid>
      </Grid>
    </HomeSection>
  );
};

export default MyExamCases;
